/** @jsxImportSource @gongxigames/framework/core/fragments/BuilderY */
/** @jsxRuntime automatic */

import {FC, CanBeSignals, ContainerProps, mapProp} from '@gongxigames/framework/core/fragments/BuilderY';
import {$ButtonRuby} from '@gongxigames/framework/slotV2/ui/ui-ruby/JSX/ButtonRuby';
import {ReelsSpeedLevel} from '@gongxigames/framework/slotV2/types';

export type TurboBtnProps = Omit<ContainerProps, 'name'> & CanBeSignals<{
    currentLevel: ReelsSpeedLevel;
    disabled?: boolean;
    action?: () => void;
}>;

const ICON_MAPPING: Record<ReelsSpeedLevel, string> = {
    [ReelsSpeedLevel.normal]: 'btn_icon_turbo1',
    [ReelsSpeedLevel.turbo_1]: 'btn_icon_turbo2',
    [ReelsSpeedLevel.turbo_2]: 'btn_icon_turbo3',
};

const BG_MAPPING: Record<ReelsSpeedLevel, string> = {
    [ReelsSpeedLevel.normal]: 'wide_btn_bg',
    [ReelsSpeedLevel.turbo_1]: 'wide_btn_bg',
    [ReelsSpeedLevel.turbo_2]: 'wide_btn_bg_gold',
};

export const $TurboBtn: FC<TurboBtnProps> = (props) => {
    const icon = mapProp(props.currentLevel, level => ICON_MAPPING[level]);
    const bg = mapProp(props.currentLevel, level => BG_MAPPING[level]);

    return <$ButtonRuby
        {...props}
        name='turbo_btn'
        icon={icon}
        bg={bg}
        hitArea='wide'
    />;
};